import { Injectable } from '@angular/core';
import { LoadingController } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { UserData } from '../../../../providers/user-data';
import { PageRef } from '../../../../core/core.module';

@Injectable()
export class AccountCommon {
	
	public currentUser: any;
	public nameInitials: string;
	
	constructor(
		public loadingCtrl: LoadingController,
		public userData: UserData,
    	public pageRef: PageRef,
	) {


	}

	public commonMethod(){
		console.log("Hello Account");
	}

	public loadUserData(nav){
		let self = this;

		let loader = self.loadingCtrl.create();
		loader.present();	
		self.userData.getUser().subscribe((user) => {
			if(!user){
				if(loader){
					loader.dismiss();
				}
				nav.setRoot(LoginPage);
			}
			self.currentUser = user;
			self.userData.getUserNameInitials().subscribe((name) => {
				self.nameInitials = name;
				if(loader){
					loader.dismiss();
				}
			});			
		});
	}

	public signOut(nav){
		let self = this;
		//if (!redirectPage){ redirectPage = 'login' }
		this.userData.logout().subscribe(success=>{
			if(success){
				self.currentUser = null;
				self.nameInitials = '';
				nav.setRoot(LoginPage);
				//nav.setRoot(self.pageRef.get(redirectPage));
			}
		});

	}
}



// WEBPACK FOOTER //
// ./src/modules/account/pages/account/account.common.ts